import { useInfiniteQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Modal from '../../../components/common/Modal';
import modalImg01 from '../../../assets/pay_popup01.png';

const ScheduleSection = ({ classId, teacherId }) => {
	const API_URL = import.meta.env.VITE_API_URL;
    const navigate = useNavigate();

	const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
		queryKey: ['scheduleList', { classId, teacherId }],
		queryFn: async ({ pageParam = 1 }) => {
			const params = new URLSearchParams();
		  	if (classId) params.append('cl_id', classId);
			if (teacherId) params.append('te_id', teacherId);
			params.append('page', pageParam);

			const res = await fetch(`${API_URL}/bbs/ajax.get_schedule_list.php?${params.toString()}`);
			return res.json();
		},
		getNextPageParam: (lastPage) => {
			const currentPage = lastPage.data.pagination.page;
			const totalPage = lastPage.data.pagination.total_page;
			return currentPage < totalPage ? currentPage + 1 : undefined;
		}
	});
	const items = data?.pages.flatMap(page => page.data?.list ?? []) ?? [];

	const formatSchedule = (datetime) => {
		const date = new Date(datetime.replace(" ", "T"));
		const now = new Date();
		const days = ["일", "월", "화", "수", "목", "금", "토"];
		const year = date.getFullYear();
		const monthDay = `${date.getMonth() + 1}.${date.getDate()}`;
		const dayName = days[date.getDay()];
		const hours = date.getHours();
		const minutes = date.getMinutes().toString().padStart(2, "0");
		const period = hours >= 12 ? "오후" : "오전";
		const hour12 = hours % 12 || 12;
		return {
			year,
			monthDay,
			dayName,
			time: `${period} ${hour12}:${minutes}`,
			isPast: date < now,
		};
	};

	// 모달 관리
	const [showModal, setShowModal] = useState(false);
	const [moveTimeout, setMoveTimeout] = useState(null);
	const handleApply = (link) => {
		if (!link) {
			alert("준비중입니다.");
			return;
		}
		setShowModal(true);
		const timeout = setTimeout(() => {
			setShowModal(false);
			const callback = () => {window.open(link, '_self', 'noopener,noreferrer');};
			if (window.gtag) {
				window.gtag('event', 'conversion', {
					send_to: 'AW-18144019506/bJddCOGg96scELKI38tD',
					value: 1.0,
					currency: 'KRW',
					event_callback: callback,
				});
				setTimeout(callback, 1000);
			} else {
				callback();
			}
		}, 3000);
		setMoveTimeout(timeout);
	};
	const handleCloseModal = () => {
		if (moveTimeout) {
			clearTimeout(moveTimeout);
			setMoveTimeout(null);
		}
		setShowModal(false);
	};

	return (
		<div>
			<div className="flex flex-wrap gap-3">
				{items.length === 0 ? (
					<div className="text-gray-400 text-center py-4">
						예정 스케줄이 없습니다.
					</div>
				) : (
					items.map((item) => {
						const { year, monthDay, dayName, time, isPast } = formatSchedule(item.start);

						return (
							<div
								key={item.id}
								onClick={() => {
									if (!isPast) {
										handleApply(item.link);
									}
								}}
								className={`
									group px-4 py-3 rounded-xl border-2 transition-all duration-200
									flex flex-col items-center text-center gap-1 shadow-sm select-none
									${isPast
										? "opacity-40 cursor-not-allowed border-gray-200 bg-gray-50"
										: "text-gray-700 border-[#eee] hover:border-purple-400 hover:bg-purple-50 hover:shadow-md active:scale-[0.98] cursor-pointer"
									}
								`}
							>
								<span className="font-semibold text-[15px]">
									{monthDay} ({dayName})
								</span>

								<span className="text-sm text-gray-500">
									{time}
								</span>

								<span
									className={`mt-1 text-xs font-medium ${
										isPast ? "text-gray-400" : "text-purple-500"
									}`}
								>
									신청하기 →
								</span>
							</div>
						);
					})
				)}
			</div>
			{hasNextPage && (
				<button onClick={() => fetchNextPage()} className="text-gray-700">
					더보기
				</button>
			)}
			<Modal isOpen={!!showModal} onClose={handleCloseModal}>
				<div className="relative">
					<button
						onClick={handleCloseModal}
						className="absolute top-5 right-5 w-[45px] h-[45px]"
					>
					</button>  
				</div>
				{showModal && (
					<img
						src={modalImg01}
						alt="Feature"
						className="w-full h-auto rounded-lg object-contain"
						/>
						)}
				{showModal && (
					<p className="w-full text-center mt-3 text-white font-bold" >잠시만 기다리시면 신청페이지로 이동합니다</p>
					)}
			</Modal>
		</div>
	);
};

export default ScheduleSection;